export default {
  name: 'LoginComponent',
  props: {
    isCms: {
      type: Boolean,
      default: false
    },
    login: {
      type: Function
    },
    viewRegister: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    },
    isFinalWarning: {
      type: Boolean,
      default: false
    },
    viewResetPass: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      id: '',
      password: '',
      isPasswordVisible: false
    };
  },
  computed: {
    subTitle: function subTitle() {
      return this.isCms ? '【選考評価担当・管理者用】' : '【申請者用】';
    },
    errorMsg: function errorMsg() {
      return this.msg;
    },
    resetPassUrl: function resetPassUrl() {
      if (this.isCms) {
        return '/cms/identify/password/recover';
      }
      return '/identify/password/recover';
    }
  },
  methods: {
    kickLogin: function kickLogin() {
      var inputs = {
        login_id: this.id,
        password: this.password
      };
      this.login(inputs);
    },
    goInitMail: function goInitMail() {
      this.$router.push({
        name: 'gasRegisterInit'
      });
    }
  }
};